import type { WidgetConfig as WC } from '@/generated/graphql';
import { take } from '@/helpers/takePayload';

export type WidgetConfig = {
  id?: number;
  description: string;
  loaderUrl: string;
  embedUrl: string;
  configuration: string;
};

export const fromGql = (config: WC): WidgetConfig => ({
  ...(take(config, 'id', 'description', 'loaderUrl', 'embedUrl', 'configuration', 'style') as WidgetConfig),
});
